module.exports = __webpack_public_path__ + "media/journey1-0.04869f2e.mp4";